'use es6';

import { dispatchQueue } from 'crm_data/dispatch/Dispatch';
import { ASSOCIATED_OPEN_OBJECTS } from 'crm_data/actions/ActionNamespaces';
export function refreshAssociatedOpenObjects(associatedObjects) {
  dispatchQueue(`${ASSOCIATED_OPEN_OBJECTS}_REFRESH_QUEUED`, associatedObjects);
}